import { useField } from "formik";
import Button from "@mui/material/Button";
import FormHelperText from "@mui/material/FormHelperText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import FileNodeType from "../../types/FileNodeType";

const FileNode = (node: FileNodeType) => {
    const [, meta, helpers] = useField(node.name);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.currentTarget.files;
        if (!files) return;
        helpers.setValue(node.multiple ? Array.from(files) : files[0]);
    };

    return (
        <Stack spacing={0.5}>
            {node.label && (
                <Typography variant="body2" color="text.secondary">
                    {node.label}
                </Typography>
            )}
            <Button
                variant="outlined"
                component="label"
                disabled={!!node?.isSubmitting}
                sx={{ alignSelf: "flex-start" }}
            >
                Chọn file
                <input
                    hidden
                    type="file"
                    accept={node.accept}
                    multiple={node.multiple}
                    onChange={handleChange}
                />
            </Button>
            {meta.touched && meta.error && (
                <FormHelperText error>{meta.error}</FormHelperText>
            )}
        </Stack>
    );
};

export default FileNode;
